import { render, staticRenderFns } from "./appCompose.vue?vue&type=template&id=5187c30e&scoped=true&"
import script from "./appCompose.vue?vue&type=script&lang=js&"
export * from "./appCompose.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=5187c30e&prod&lang=scss&scoped=true&"
import style1 from "./appCompose.vue?vue&type=style&index=1&id=5187c30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187c30e",
  null
  
)

export default component.exports